export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [6,[2]],
		"/(app)/account": [7,[2]],
		"/(app)/admin/accounts": [8,[2,3]],
		"/(app)/admin/accounts/[account_id]": [9,[2,3]],
		"/(app)/analytics": [10,[2,4]],
		"/(app)/analytics/automation": [11,[2,4]],
		"/(app)/analytics/tasks": [12,[2,4]],
		"/(app)/analytics/validation": [13,[2,4]],
		"/(app)/api": [14,[2]],
		"/(app)/file-system-agent": [15,[2]],
		"/forbidden": [29],
		"/(app)/isometric-showcase": [16,[2]],
		"/(app)/ops/loanlogics": [17,[2]],
		"/(app)/projects": [18,[2]],
		"/(app)/projects/library": [24,[2]],
		"/(app)/projects/[project_id]": [19,[2,5]],
		"/(app)/projects/[project_id]/about": [20,[2,5]],
		"/(app)/projects/[project_id]/automation": [21,[2,5]],
		"/(app)/projects/[project_id]/configuration": [22,[2,5]],
		"/(app)/projects/[project_id]/validation": [23,[2,5]],
		"/(app)/status": [25,[2]],
		"/(app)/tasks": [26,[2]],
		"/(app)/usage": [27,[2]],
		"/(app)/users": [28,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';